import React, { useState } from "react";
import styled from "styled-components";

import DeleteIconHover from '../../image/Delete(stroke)_hover.svg';
import DeleteIcon from '../../image/Delete(stroke).svg';

export default function MultiLoginAccountView(props) {
  const { data, onSwitchAccount, onDeleteAccount } = props;

  const [isHover, setIsHover] = useState(false);

  return (
    <AccountItemWrapper onClick={() => onSwitchAccount(data.account)}>
      <AccountInfoWrapper>
        <AccountLogo src={data.storeLogo} />
        <AccountName>{data.storeName}</AccountName>
      </AccountInfoWrapper>
      <AccountDeleteButtonWrapper 
        isHover={isHover}
        onMouseEnter={() => setIsHover(true)} 
        onMouseLeave={() => setIsHover(false)} 
        onClick={(e) => onDeleteAccount(e, data.account)}>
        <AccountDeleteHoverButton isHover={isHover} src={DeleteIconHover}/>
        <AccountDeleteButton isHover={isHover} src={DeleteIcon}/>
      </AccountDeleteButtonWrapper>
    </AccountItemWrapper>
  )
}


const AccountItemWrapper = styled.div`
  display: flex;

  justify-content: space-between;
  align-items: center;

  padding: 8px 10px;
  margin: 0 5px;

  width: calc(100% - 10px);

  border-radius: 20px;
  border: 1px solid transparent;

  box-sizing: border-box;

  transition: all 0.3s ease-in-out;

  &:hover {
    cursor: pointer;
    background: rgba(255, 255, 255, 0.2);
    backdrop-filter: blur(10px);
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.03);
    border: 1px solid rgba(255, 255, 255, 0.3);
  }

  &:has(img:hover) {
    background: rgba(217, 40, 40, 0.20);
    border: 1px solid rgba(217, 40, 40, 0.40);
    transition: all 0.3s ease-in-out;
  }
`;

const AccountInfoWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;
`;

const AccountLogo = styled.img`
  margin-right: 12px;

  width: 40px;
  height: 40px;

  border-radius: 40px;

  background-color: rgba(255, 255, 255, 0.25);
`;

const AccountName = styled.div`
  font-family: NotoSansKR-Medium;
  font-size: 18px;

  color: #ffffff;

  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 280px;
`;

const AccountDeleteButtonWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 20px;
  height: 20px;

  &:hover {
    cursor: pointer;
  }

  transition: all 0.3s ease-in-out;
`;

const AccountDeleteButton = styled.img`
  position: absolute;

  width: 100%;
  height: 100%;

  opacity: ${props => props.isHover ? '0' : '0.7'};

  transition: all 0.3s ease-in-out;
`;

const AccountDeleteHoverButton = styled.img`
  position: absolute;

  width: 100%;
  height: 100%;

  opacity: ${props => props.isHover ? '1' : '0'};

  transition: all 0.3s ease-in-out;
`;